import { API_TAGS } from '../../constants/api';
import { apiSlice } from '../apiSlice';

export const CSATSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCSATSections: builder.query({
      query: ({ orgId, urlParams = {} }) => ({
        url: `organizations/${orgId}/csat-sections`,
        method: 'GET',
        params: {
          ...urlParams
        }
      }),
      providesTags: (result, error, args) => {
        return [
          { type: API_TAGS.CSAT, id: 'LIST' }
        ];
      }
    }),
    createCSATSection: builder.mutation({
      query: ({ orgId, data }) => ({
        url: `organizations/${orgId}/csat-sections`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: (_result, error, args) => {
        return [
          { type: API_TAGS.CSAT, id: 'LIST' }
        ];
      }
    }),
    updateCSATSection: builder.mutation({
      query: ({ orgId, CSATSectionId, data }) => ({
        url: `organizations/${orgId}/csat-sections/${CSATSectionId}`,
        method: 'PATCH',
        body: data
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        return [
          { type: API_TAGS.CSAT, id: 'LIST' }
        ];
      }
    }),
    deleteCSATSection: builder.mutation({
      query: ({ orgId, CSATSectionId }) => ({
        url: `organizations/${orgId}/csat-sections/${CSATSectionId}`,
        method: 'DELETE'
      }),
      transformResponse: () => true,
      invalidatesTags: (_result, error, args) => {
        return [
          { type: API_TAGS.CSAT, id: 'LIST' }
        ];
      }
    })
  })
});

export const {
  useFetchCSATSectionsQuery,
  useCreateCSATSectionMutation,
  useUpdateCSATSectionMutation,
  useDeleteCSATSectionMutation
} = CSATSlice;
